import { render, staticRenderFns } from "./ac-simple-card.vue?vue&type=template&id=037e2d96&scoped=true&"
import script from "./ac-simple-card.vue?vue&type=script&lang=js&"
export * from "./ac-simple-card.vue?vue&type=script&lang=js&"
import style0 from "./ac-simple-card.vue?vue&type=style&index=0&id=037e2d96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037e2d96",
  null
  
)

export default component.exports